import React, { Component } from "react";
import {
  Grommet,
  Box,
  Spinner,
  grommet,
  Header,
  Button,
  Menu,
  Main,
  Heading,
  Paragraph,
  Footer,
  Text,
  Anchor,
  DropButton,
  Stack,
  Avatar,
  TextInput,
  Grid,
  Card,
  Form,
  FormField,
  CheckBoxGroup,
  Select,
  CardHeader,
  CardBody,
  List,
  Image,
  CheckBox,
  DateInput,
  Tabs,
  Tab,
} from "grommet";
import {
  Hpe,
  More,
  Help,
  Channel,
  Notification,
  Search,
  New,
  Like,
  Directions,
  Favorite,
  FormPrevious,
  Filter,
  Dislike,
  Chat,
  Share,
  Download,
  ScheduleNew,
  Launch,
  AddCircle,
  Edit,
  Trash,
  Validate,
  Clear,
  Play,
  Multimedia,
  DocumentPdf,
  Inspect,
  Console,
  Mail,
  Chrome,
} from "grommet-icons";
import { hpe as theme } from "grommet-theme-hpe";
import { withRouter } from "react-router-dom";
import Alert from "@material-ui/lab/Alert";
import {
  callApiPostJson,
  callApiText,
  postFormData,
  injectStyle,
  release,
  logAccess,
  callApiGetJson,
  APIServerURL,
  callApiValidatePort,
  envKey,
} from "./Components/GlobalSettings";
import { auth } from "./Components/Security/Auth";
import queryString from "query-string";
import hpeBgImg from "./assets/hpe-bg.jpg";
import Login from "./assets/Login.jpg";
import FirstTimeUser from "./Components/FirstTimeUser";
import CustomerLogin from "./LoginCustomer";
import { showToast } from "./common/UtilityHelper";
import "./App.css";
import CustomerResetPassword from "./Components/CustomerResetPassword";
import {
  FormatColorResetTwoTone,
  FormatListBulletedRounded,
} from "@material-ui/icons";
/* const RouterContext = React.createContext({})

const Router = ({ children }) => {
  const [path, setPath] = React.useState("/login")

  React.useEffect(() => {
    const onPopState = () => setPath(document.location.pathname)
    window.addEventListener('popstate', onPopState)
    return () => window.removeEventListener('popstate', onPopState)
  }, [])

  const push = nextPath => {
    if (nextPath !== path) {
      window.history.pushState(undefined, undefined, nextPath)
      setPath(nextPath)
      window.scrollTo(0, 0)
    }
  }

  return (
    <RouterContext.Provider value={{ path, push }}>
      {children}
    </RouterContext.Provider>
  )
}

const Routes = ({ children }) => {
  const { path: contextPath } = React.useContext(RouterContext)
  let found
  Children.forEach(children, child => {
    if (!found && contextPath === child.props.path) found = child
  })
  return found
}

const Route = ({ Component, path }) => {
  const { path: contextPath } = React.useContext(RouterContext)
  return contextPath === path ? <Component /> : null
} */

class LoginSet extends Component {
  constructor(props) {
    super(props);

    this.state = {
      data: "Initial data...",
      navbarFlag: false,
      userMessage: undefined,
      hasAllRegistrationData: true,
      showEmployeePartnerLoginPage: false,
      showLoginErr: false,
      loginErrMsg: "Error in your Account Login",
      showCustomerLoginPage: false,
      showLoginSelectionPage: true,
      showPasswordResetPage: false,
      emailToImpersonate: undefined,
      tokenToImpersonate: undefined,
      showHPEPassportRegistrationPage: false,
      email: undefined, //'mishra.anurag@hpe.com',
      pass: "",
      disableLoginButton: true,
      hpeUIDDisable:
        release === "DEV" || release === "PRO" || release === "ITG"
          ? false
          : true,
      resetPasswordErrorText: undefined,
      newCustomerRegister: {
        UserID: null,
        EmailAddress: null,
        FirstName: null,
        LastName: null,
        Password: null,
        ConfirmPassword: null,
        UserType: "3",
      },
      isRequiredPortOpen: true,
      isOldIE: false,
      IEPopup: false,
      showLoadingCustReset: false,
      custPwdResetMessage: undefined,
      showCustPwdResetView: false,
      PwdResetGuid: undefined,
    };

    this._HPELoginClick = this._HPELoginClick.bind(this);
    this._PartnerLoginClick = this._PartnerLoginClick.bind(this);
    this._completePartnerLogin = this._completePartnerLogin.bind(this);
    /* this._CustomerLoginClick = this._CustomerLoginClick.bind(this);
      this._handleCustomerLoginSubmit = this._handleCustomerLoginSubmit.bind(this);
      this._handleEmailChange = this._handleEmailChange.bind(this);
      this._handlePasswordChange = this._handlePasswordChange.bind(this);
      this._handleBackButtonClick = this._handleBackButtonClick.bind(this); */
    this.hasAllRegistrationData = this.hasAllRegistrationData.bind(this);
    this._completeHPEUIDLogin = this._completeHPEUIDLogin.bind(this);
    /*  this._handleResetPasswordFinalize = this._handleResetPasswordFinalize.bind(this);
      this._handleResetPasswordVerify = this._handleResetPasswordVerify.bind(this);
      this._handleResetPassword1Change = this._handleResetPassword1Change.bind(this);
      this._handleForgotPasswordClicked = this._handleForgotPasswordClicked.bind(this);
      this._handleRegistrationPageSubmit = this._handleRegistrationPageSubmit.bind(this);
      this._handleRegisterClicked = this._handleRegisterClicked.bind(this);
      this._handleForgotPasswordPageSubmit = this._handleForgotPasswordPageSubmit.bind(this);
      this.validatePasswordResetGUID = this.validatePasswordResetGUID.bind(this);
      this._handleRegBackButtonClick = this._handleRegBackButtonClick.bind(this);
      this.validatePort = this.validatePort.bind(this); */
    this.validateQueryString = this.validateQueryString.bind(this);
    this.validateQueryStringOkta = this.validateQueryStringOkta.bind(this);
    this.ApiPostString = this.ApiPostString.bind(this);
    this.hpeUIDAuthRequest = this.hpeUIDAuthRequest.bind(this);
    this._HPECustloginClick = this._HPECustloginClick.bind(this);
    this._HideCustLogin = this._HideCustLogin.bind(this);
    this._HideCustReset = this._HideCustReset.bind(this);
    this.validatePasswordResetGUID = this.validatePasswordResetGUID.bind(this);
    this.handleImpersonateTrue = this.handleImpersonateTrue.bind(this);

    // this._onCloseNotSupportedBrowser = this._onCloseNotSupportedBrowser.bind(this);
  }

  componentDidMount() {
    console.log("*****Pros Below*****");
    //console.log(new URLSeatchParams(this.props.router));
    console.log(queryString.parse(this.props.location.search).code);

    console.log("*****Pros Below to catch impersonation UCs*****");
    //console.log(new URLSeatchParams(this.props.router));
    console.log(queryString.parse(this.props.location.search).impersonate);
    console.log(queryString.parse(this.props.location.search).imptoken);

    console.log("*****Pros Below to Fetch name Querystring *****");
    //console.log(new URLSeatchParams(this.props.router));
    console.log(queryString.parse(this.props.location.search).name);

    console.log("*****Pros Below to Fetch demoid Querystring *****");
    //console.log(new URLSeatchParams(this.props.router));
    console.log(queryString.parse(this.props.location.search).demoid);

    console.log("*****Pros Loc srch only Below*****");
    console.log(queryString.parse(this.props.location.search));

    console.log("***Props and things below***");
    console.log(this.props);
    console.log(
      "Does path has search in it",
      this.props.location.pathname.toString().includes("search")
    );
    console.log(this.props.location.state);
    console.log(this.props.location.nextPathname);
    console.log(this.props.router);
    //console.log(window.location.search).get("token");

    //if(this.props.location.query.hpeuidtoken !== undefined) this._completeHPEUIDLogin();//hpeuidlogin token found from HPEUID - _handleEventRequestSubmit request to finish login
    // if(queryString.parse(this.props.location.search).code !== undefined) this._completeHPEUIDLogin();

    if (
      queryString.parse(this.props.location.search).impersonate &&
      queryString.parse(this.props.location.search).imptoken
    ) {
      console.log("Something caught for impersonation as below ");
      console.log(
        "email to impersonate ",
        queryString.parse(this.props.location.search).impersonate
      );
      console.log(
        "auth token used to make impersonate call ",
        queryString.parse(this.props.location.search).imptoken
      );
      this.setState({
        tokenToImpersonate: queryString.parse(this.props.location.search)
          .imptoken,
        emailToImpersonate: queryString.parse(this.props.location.search)
          .impersonate,
      });
      this.handleImpersonateTrue(
        queryString.parse(this.props.location.search).imptoken,
        queryString.parse(this.props.location.search).impersonate
      );
    }

    if (
      queryString.parse(this.props.location.search).name &&
      queryString.parse(this.props.location.search).name.length > 3
      //this.props.location.pathname.toString().includes("search")
    ) {
      auth.setSearchParam(queryString.parse(this.props.location.search).name);
    }

    if (
      queryString.parse(this.props.location.search).demoid &&
      queryString.parse(this.props.location.search).demoid.length > 3
      //this.props.location.pathname.toString().includes("search")
    ) {
      auth.setSearchDemoIdParam(
        queryString.parse(this.props.location.search).demoid
      );
    }

    if (
      queryString.parse(this.props.location.search).t1 !== undefined &&
      queryString.parse(this.props.location.search).t1.length >= 3
      //this.props.location.pathname.toString().includes("search")
    ) {
      auth.setT1CategoryParam(queryString.parse(this.props.location.search).t1);
    }

    if (
      queryString.parse(this.props.location.search).t2 !== undefined &&
      queryString.parse(this.props.location.search).t2.length >= 3
      //this.props.location.pathname.toString().includes("search")
    ) {
      auth.setT2CategoryParam(queryString.parse(this.props.location.search).t2);
    }

    if (
      queryString.parse(this.props.location.search).prod !== undefined &&
      queryString.parse(this.props.location.search).prod.length >= 3
      //this.props.location.pathname.toString().includes("search")
    ) {
      auth.setProdParam(queryString.parse(this.props.location.search).prod);
    }

    if (
      queryString.parse(this.props.location.search).code !== undefined &&
      queryString.parse(this.props.location.search).session_state !== undefined
    ) {
      this.validateQueryString();
    }
    if (
      queryString.parse(this.props.location.search).code !== undefined &&
      queryString.parse(this.props.location.search).state !== undefined
    ) {
      this.validateQueryStringOkta();
    }
    if (
      queryString.parse(this.props.location.hash).code !== undefined &&
      queryString.parse(this.props.location.hash).state !== undefined
    ) {
      console.log(
        "Received OKTA # code value is ",
        queryString.parse(this.props.location.hash).code
      );
      console.log(
        "Received OKTA # state value is ",
        queryString.parse(this.props.location.hash).state
      );
      //this.validateQueryString();
    }
    if (queryString.parse(this.props.location.search).tokenId !== undefined) {
      this._completePartnerLogin(); //tokenId token found from PRP - _handleEventRequestSubmit PRP login request to finish login
    }
    if (
      queryString.parse(this.props.location.search).resetpassword !== undefined
    ) {
      console.log(
        "Customer Pwd Reset code is ",
        queryString.parse(this.props.location.search).resetpassword
      );
      this.setState({
        PwdResetGuid: queryString.parse(this.props.location.search)
          .resetpassword,
      });
      this.validatePasswordResetGUID(
        queryString.parse(this.props.location.search).resetpassword
      );
    }

    if (auth.loggedIn()) {
      this.props.history.push("/home");
    } else {
      this.props.history.push("/");
    }
    /*
      if(this.props.location.query.resetpassword !== undefined)
          this.validatePasswordResetGUID(this.props.location.query.resetpassword);  */
  }

  handleImpersonateTrue(tokenToImpersonate, emailToImpersonate) {
    console.log("Token  Val is", tokenToImpersonate);
    console.log("Email  Val is", emailToImpersonate);
    this.setState({ showLoadingPage: true });
    let endpoint = "/Account/Impersonate";
    let token = tokenToImpersonate; //auth.getToken(); // need to set this token value as value received from Admin console
    var fileSubmit = new FormData();
    fileSubmit.append("username", emailToImpersonate);
    //fileSubmit.append("username", this.ImpersonateEmailId);
    var postData = fileSubmit;
    postFormData(endpoint, postData, token).then((data) => {
      console.log(data);
      let expiresDateMilliseconds = Date.now() + data.expires_in * 1000;
      localStorage.setItem("token", data.access_token);
      localStorage.setItem("tokenexpires", expiresDateMilliseconds);
      localStorage.setItem("email", data.email);
      localStorage.setItem("userinfo", JSON.stringify(data.UserInfo));
      localStorage.removeItem("userimgData");
      //this.setState({ImpersonateOverlay:false});
      // var isAuth = auth.isAuthenticated();

      //if (isAuth) {
      window.location.href = "/home";
      /* } else {
        this.setState({ showLoadingPage: false });
        console.log("Error in User Login");
      } */
    });
  }

  validatePasswordResetGUID(GUID) {
    if (GUID) {
      this.setState({ showLoadingCustReset: true });
      console.log("validatePasswordResetGUID page starting");
      var endpoint = "/Account/ValidatePassportGuid/" + GUID;

      callApiText(endpoint, undefined).then((data) => {
        console.log("validatePasswordResetGUID data:", data);
        if (data === "true") {
          console.log("showPasswordResetPage - true");
          this.setState({
            showCustPwdResetView: true,
            showLoadingCustReset: false,
          });
        } else {
          console.log("showPasswordResetPage - false");
          this.setState({
            showCustPwdResetView: false,
            showLoadingCustReset: false,
          });
          showToast({
            message: "Customer Registration Code failed validation !",
            intent: "danger",
          });
        }
      });
    }

    // return false;
  }

  hasAllRegistrationData() {
    //Verifies user profile data.
    var UserInfo = auth.getUserInfo();
    console.log("Verify user has Registration info :", UserInfo);
    if (
      !UserInfo ||
      !UserInfo.TimeZone ||
      !UserInfo.UserLocation ||
      !UserInfo.UserLocation.Country ||
      !UserInfo.Job ||
      !UserInfo.UserExpertise ||
      !UserInfo.UserExpertise.ExpertLevelName
    )
      return false;

    console.log("Verify user has Registration info returning TRUE");
    console.log(UserInfo);
    return true;
  }

  _PartnerLoginClick() {
    localStorage.removeItem("recentpopup");
    //window.location = "https://partner-itg.itcs.hpe.com/group/upp-emea/esm/-/link/31926"; //temp login CHANGE
    window.location =
      release === "PRO"
        ? "https://partner.hpe.com/o/delegate/esm/189104" // applied correct one
        : "https://partner-stg3.it.hpe.com/group/prp/esm/-/link/189104";

    // :  "https://partner.hpe.com/o/delegate/esm/189104"
    //    "https://prp-dxp.it.hpe.com/o/delegate/esm/189104"
    //  : "https://partner-stg3.it.hpe.com/web/prp";

    // : "https://partner-stg3.it.hpe.com/o/delegate/esm/189104";

    // : "https://partner-stg2.it.hpe.com/o/delegate/esm/189104";

    // : "https://partner-stg1.it.hpe.com/o/delegate/esm/189104";

    //: "https://partner-itg.itcs.hpe.com/delegate/esm/192103";
  }

  _completeHPEUIDLogin() {
    this.setState({ showLoadingPage: true });
    var token =
      queryString.parse(this.props.location.search).hpeuidtoken !== undefined;
    if (
      queryString.parse(this.props.location.search).hpeuidtoken !== undefined
    ) {
      token = queryString.parse(this.props.location.search).hpeuidtoken;
    } else if (auth.getToken() !== null) {
      token = auth.getToken();
    }
    console.log("**Token received from Backend is below ***");
    console.log(token);
    var isAuth = auth.isAuthenticated();

    if (isAuth) {
      console.log(
        "ReturnUrl from HPEUIDs: ",
        queryString.parse(this.props.location.search).ReturnUrl
      );
      logAccess(null, null, "Successful Login", "login", auth.getToken());
      const { location } = this.props.location;
      console.log(location);

      if (!this.hasAllRegistrationData()) {
        console.log("Registration data missing");
        this.setState({ hasAllRegistrationData: false });
        //this.props.router.replace('/registration');
        /*               else if (location.state && location.state.nextPathname) {
                  this.props.router.replace(location.state.nextPathname)
              } else if(queryString.parse(this.props.location.search).ReturnUrl !== undefined){
                  this.props.router.replace(queryString.parse(this.props.location.search).ReturnUrl); */
      } else {
        // After 0365 login , redirect to previous path,
        /*                   if (window.localStorage.hasOwnProperty('previousPath')) {
                      let previousPath = window.localStorage.getItem("previousPath");
                      this.props.router.replace(previousPath);
                      window.localStorage.removeItem('previousPath');
                  } else { //  no previous path
                      this.props.router.replace('/')
                  } */
        console.log("**This is time to route to Home**");
        this.props.history.push("/home");
      }
    } else {
      console.log("Error logging in.");
      this.setState({
        // userMessage: <Toast status='critical'> Error logging in.  Please retry. </Toast>,
        disableLoginButton: false,
        showLoadingPage: false,
      });
      this.props.history.push("/");
      // this.props.router.replace("/");
    }
  }

  _completePartnerLogin() {
    this.setState({ showLoadingPage: true });
    auth.loginHPEPartner(
      queryString.parse(this.props.location.search).tokenId,
      (isAuth) => {
        console.log("CompletePartnerLogin - Logged In: " + isAuth);
        if (isAuth) {
          logAccess(null, null, "Successful Login", "login", auth.getToken());
          const { location } = this.props;

          if (!this.hasAllRegistrationData()) {
            console.log("Registration data missing for Partner");
            this.setState({ hasAllRegistrationData: false });

            //this.props.history.push("/register");
            // this.props.router.replace('/registration');
          } else {
            /*             else if (location.state && location.state.nextPathname) {
                this.props.router.replace(location.state.nextPathname)
            } else {
                this.props.router.replace('/')
            } */
            this.props.history.push("/home");
          }
        } else {
          console.log("Error logging in.");
          this.setState({
            /* userMessage: <Toast status='critical'> Error logging in. Please retry. </Toast>,
                disableLoginButton: false,
                showLoadingPage: false */
          });
          this.props.router.replace("/");
        }
      }
    );
  }

  _HPECustloginClick() {
    var endpoint = APIServerURL + "/Account/uidlogin/";
    window.location = endpoint;
    // this.setState({ showCustomerLoginPage: true });
    // this.props.history.push("/customerlogin");
  }

  _HideCustLogin() {
    this.setState({ showCustomerLoginPage: false });
  }

  _HideCustReset() {
    this.setState({ showCustPwdResetView: false });
  }

  _HPELoginClick() {
    localStorage.removeItem("recentpopup");
    if (this.state.hpeUIDDisable) {
      console.log("UIDDisable set to ", this.state.hpeUIDDisable);
      this.setState({
        showEmployeePartnerLoginPage: true,
        showCustomerLoginPage: false,
        showLoginSelectionPage: false,
        hasAllRegistrationData: true,
        pass: "password1",
        userMessage: undefined,
      });
    } else {
      // window.location = "https://solutionsdepot.int.hpe.com/HPEUIDLogin/ProcessHPEUIDLogin.aspx?demoPortal=" + (release === "PRO" ? "2" : "1") + '&returnUrl=' + (this.props.location && this.props.location.state && this.props.location.state.nextPathname ? this.props.location.state.nextPathname: '');
      // window.location="https://hpedemoportal-itg.ext.hpe.com:4433/DemoPortal/api/uidlogin"
      //var endpoint = '/Account/uidlogin/';
      // let token = auth.getToken();

      /*            callApiGetJson(endpoint, null).then(data => {
                          if (data !== undefined) {
                              console.log("*****",data);
                          }
                      });*/
      var endpoint = APIServerURL + "/Account/uidlogin/";
      window.location = endpoint;
      /*setTimeout(() => {
              console.log("10 Sec ...")
          }, 10000);*/
      //this.validateQueryString();
    }
  }

  validateQueryStringOkta() {
    this.setState({ showLoadingPage: true });
    const urlParams = new URLSearchParams(window.location.search);
    var postData;
    var endpoint = "/Account/authorizeuser";
    if (urlParams.has("code") && urlParams.has("state")) {
      postData = {
        code: urlParams.get("code"),
        session_state: urlParams.get("state"),
      };
      this.hpeUIDAuthRequest(postData, (res) => {
        console.log("res.token:" + res.token);
        console.log("res.UserInfo: ", res.userinfo);
        console.log("res.imageData", res.usrimgdata);
        console.log("Full User Login Response dump is ", res);

        if (res.authenticated === true) {
          console.log(
            "In case if res authentication returns true from Backend",
            res.authenticated
          );
          auth.setNewLocalStorage(res);
        } else {
          if (
            res.token.includes(
              "There are more than one User Type accounts available for this user"
            )
          ) {
            this.setState({
              showLoginErr: true,
              loginErrMsg:
                "Error - Duplicate account found : please contact support team (click on need help)",
            });
          } else {
            this.setState({
              showLoginErr: true,
              loginErrMsg:
                "Error - Please contact support team (click on need help)",
            });
          }
        }
        this._completeHPEUIDLogin();
      });
    }
  }

  validateQueryString() {
    this.setState({ showLoadingPage: true });
    const urlParams = new URLSearchParams(window.location.search);
    var postData;
    var endpoint = "/Account/authorizeuser";
    if (urlParams.has("code") && urlParams.has("session_state")) {
      postData = {
        code: urlParams.get("code"),
        session_state: urlParams.get("session_state"),
      };
      this.hpeUIDAuthRequest(postData, (res) => {
        console.log("res.token:" + res.token);
        console.log("res.UserInfo: ", res.userinfo);
        console.log("res.imageData", res.usrimgdata);
        console.log("Full User Login Response dump is ", res);

        if (res.authenticated === true) {
          console.log(
            "In case if res authentication returns true from Backend",
            res.authenticated
          );
          auth.setNewLocalStorage(res);
        } else {
          if (
            res.token.includes(
              "There are more than one User Type accounts available for this user"
            )
          ) {
            this.setState({
              showLoginErr: true,
              loginErrMsg:
                "Error - Duplicated account found : please contact support team (click on need help)",
            });
          } else {
            this.setState({
              showLoginErr: true,
              loginErrMsg:
                "Error - Please contact support team (click on need help)",
            });
          }
        }
        this._completeHPEUIDLogin();
      });
    }
  }

  ApiPostString(endpoint, postData, token) {
    let config = {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        "Env-Key": envKey,
      },
      body: JSON.stringify(postData),
    };
    return fetch(APIServerURL + endpoint, config)
      .then((response) => response.json().then((json) => ({ json, response })))
      .then(({ json, response }) => {
        if (!response.ok) {
          return Promise.reject(json);
        }
        return json;
        //return json
      })
      .catch((err) => err);
  }

  hpeUIDAuthRequest(postData, cb) {
    //var that = this;
    //Edit in GlobalSettings to switch to different endpoint URL
    var url = APIServerURL + "/Account/authorizeuser";

    // let bodyStr = "hpeuidtoken=" + encodeURIComponent(token);
    var myInit = {
      method: "POST",
      mode: "cors",
      cache: "default",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        "Env-Key": envKey,
      },
      body: JSON.stringify(postData),
    };

    fetch(url, myInit)
      .then(function (response) {
        if (response.ok) {
          if (response.status >= 400) {
            throw new Error("Bad response from server 400");
          }
          return response.json();
        } else {
          //console.log("Response not OK: " + response.status + " - " + response.statusText);
          cb({ authenticated: false });
          //throw new Error("Response not OK: " + response.status + " - " + response.statusText);
        }
      })
      .then(function (data) {
        console.log(data);
        //if(data.authenticated === true) {
        let expiresDateMilliseconds = Date.now() + data.expires_in * 1000;
        //console.log('Expire Date:' + expiresDateMilliseconds);

        cb({
          authenticated:
            data.access_token === null ||
            String(data.access_token).includes(
              "There are more than one User Type accounts available for this user"
            )
              ? false
              : true,
          token: data.access_token,
          email: data.email,
          tokenexpires: expiresDateMilliseconds,
          userinfo: data.UserInfo,
          usrimgdata: data.UserInfo.UsrImgData,
          oktaIdtoken: data.id_token,
        });
        //}
      })
      .catch((error) => {
        console.log("Error caught: " + error);
        cb({ authenticated: false });
      });
  }

  render() {
    var spinnercontent;
    var bspinnerON = false;
    var bRegReq = false;
    var UserInfo;
    var showCustLogin = false;
    var showCustPwdReset = false;

    showCustLogin = this.state.showCustomerLoginPage;
    showCustPwdReset = this.state.showCustPwdResetView;

    var Guid_Val = this.state.PwdResetGuid;

    console.log("Show Error State is, ", this.state.showLoginErr);
    console.log("Show Error Msg is, ", this.state.loginErrMsg);

    if (this.state.showLoadingPage) {
      spinnercontent = (
        <Box align="center" direction="row" gap="small" pad="small" key="small">
          <Spinner size="small" />
          <Text size="small">Loading...</Text>
        </Box>
      );
      bspinnerON = true;
    }
    console.log(
      "** Has All Registration Data state ",
      this.state.hasAllRegistrationData
    );
    if (!this.state.hasAllRegistrationData) {
      bRegReq = true;
      UserInfo = auth.getUserInfo();
    }

    return (
      //{showCustLogin && <CustomerLogin />}
      <Box fill="vertical" align="stretch" justify="start">
        {showCustLogin && <CustomerLogin hide={this._HideCustLogin} />}
        {showCustPwdReset && (
          <CustomerResetPassword
            hide={this._HideCustReset}
            GUIDVal={Guid_Val}
          />
        )}

        {!showCustLogin && (
          <Main
            overflow="auto"
            background={{
              image: `url(${Login})`,
              color: "background",
              dark: true,
            }}
            flex
            align="center"
            justify="center"
          >
            <Box
              align="center"
              justify="center"
              background={{ color: "white", white: false }}
              pad="medium"
              round="xsmall"
              gap="medium"
            >
              {this.state.showLoginErr && (
                <Box align="start" justify="start" direction="row">
                  <Alert severity="error">{this.state.loginErrMsg}</Alert>
                </Box>
              )}
              <Heading level="1" size="small" margin="none">
                HPE Demonstration Portal
              </Heading>
              <Paragraph margin="none">
                Customer, Partner and Employee level access to recorded and live
                technical demonstrations supporting the Hewlett Packard
                Enterprise business. Find demos based on technology, solutions,
                and level of expertise.
              </Paragraph>
              {spinnercontent}
              {bRegReq ? <FirstTimeUser Uinfo={UserInfo} /> : ""}
              {!bspinnerON ? (
                <Box align="center" justify="center" gap="medium">
                  <Button
                    label="HPE Employee Login"
                    primary={true}
                    color="brand"
                    fill="horizontal"
                    onClick={this._HPELoginClick}
                  />
                  <Button
                    label="HPE Partner Login"
                    primary={true}
                    color="brand"
                    fill="horizontal"
                    onClick={this._PartnerLoginClick}
                  />
                  <Button
                    label="HPE Customer Login"
                    primary={true}
                    color="brand"
                    fill="horizontal"
                    onClick={this._HPECustloginClick}
                  />
                </Box>
              ) : (
                ""
              )}

              <Paragraph>
                For the best user experience, we recommend{" "}
                <span style={{ fontWeight: "bold" }}>Chrome</span> &nbsp;
                <Chrome size="medium" color="plain" />
              </Paragraph>

              <Box
                align="center"
                justify="center"
                border={{ size: "medium", style: "solid", color: "brand" }}
                elevation="large"
                //background="Black"
                // round
                //primary
                // gap="small"
                // pad="xsmall"
              >
                <Anchor
                  icon={<Mail />}
                  margin="xsmall"
                  color="black"
                  label="Need Help ?"
                  href="mailto:sdp.demo.support.staff@hpe.com?subject=HPE%20Demo%20Portal%20Issue/Question"
                  size="xsmall"
                />
              </Box>
            </Box>
          </Main>
        )}
      </Box>
    );
  }
}
/* LoginSet.childContextTypes = {
  muiTheme: React.PropTypes.object
}; */

export default withRouter(LoginSet);

/* export default () => (
  <Grommet full theme={theme}>
    <Router>
      <Routes>
        <Route path="/login" Component={Login} />
        {/* <Route path="/home" Component={Home} />
        <Route path="/userprofile" Component={UserProfile} /> 
        <Route path="/taxonomyl1" Component={TaxonomyL1} />
        <Route path="/taxonomyl2" Component={TaxonomyL2} />
        <Route path="/listview-livedemodetail" Component={ListViewLiveDemoDetail} />
        <Route path="/t1t2products" Component={T1T2Products} />
        <Route path="/userdashboard-upcoming-demos" Component={UserDashboardUpcomingdemos} />
        <Route path="/launch-live-demo" Component={Launchlivedemo} />
        <Route path="/gethelp" Component={GetHelp} />
        <Route path="/schedule-live-demo" Component={Schedulelivedemo} />
        <Route path="/firsttimeuser" Component={FirstTimeUser} />
        <Route path="/listview-videodetail" Component={ListViewVideoDetail} />
        <Route path="/logincustomer" Component={LoginCustomer} />
        <Route path="/customerregistration" Component={CustomerRegistration} />
        <Route path="/logincustomerforgotpasswd" Component={LoginCustomerForgotPasswd} />
        <Route path="/listview" Component={ListView} />
        <Route path="/listview-documentdetail" Component={ListViewDocumentDetail} /> }
      </Routes>
    </Router>
  </Grommet> 
)*/
